/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Illegal_Characters_HintInputs */



/**
* | output |
* | --- |
* | "Remove illegal characters from the text." |
*
* @param {Error_Nav_Illegal_Characters_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_illegal_characters_hint = /** @type {((inputs?: Error_Nav_Illegal_Characters_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Illegal_Characters_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimez les caracteres illegaux du texte.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Entferne unzulässige Zeichen aus dem Text.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi i caratteri illegali dal testo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалите из текста недопустимые символы.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar caracteres ilegales del texto.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从文本中删除非法字符。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストから不正な文字を削除します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट से अवैध वर्णों को हटाएँ।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remova caracteres inválidos do texto.")
	return /** @type {LocalizedString} */ ("Remove illegal characters from the text.")
});